import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import Modal from '@synergycms_core/components/generic/Modal';
import styleFile from './availDatepickerModal.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Button, RichText } from '@synergycms_core/components/generic';
import { compose } from "ramda";
import AvailDatepicker from './AvailDatepicker.jsx';

const AvailDatepickerModal = props => {
    const { theme } = props;
    const { classes } = theme.styles;
    const {  onRangeChange, buttonEvent, closeCallback, modalTitle, modalText, room, buttonIcon } = props.config;
    const roomId = room && room.get("id");
    const keyId = room && room.get("id");
    return (
        <Modal
            innerStyle={[theme.computedInnerStyle,'modalStyle'].join(' ')}
            contentStyle={classes.noDispoModalContent}
            closeButtonStyle={classes.closeButton}
            modalStyle={classes.noDispoModal}
            closeCallback={closeCallback}
            popover={
                <div className={classes.modalTabsList}>
                    <div className={classes.headerModal}>
                        <RichText
                            innerStyle={classes.modalTitle}
                            text={modalTitle}
                            translate={true}
                            ucFirst={true}
                        />
                    </div>
                    
                    <AvailDatepicker
                        months={4}
                        onRangeChange={onRangeChange}
                        roomId={roomId}
                        key={keyId}
                        innerStyle={'availDatepickerModal'}
                    />
                </div>
            }
            typeModal={'roomDetailTooltip'}>
            <div className={classes.policiesTextToggle}>
                <Button
                    id="td-d1-calendar-subh-00"
                    onClick={buttonEvent}
                    richText={{
                        translate: true,
                        text: modalText,
                        ucFirst: true,
                        icon: {
                            content: buttonIcon ? buttonIcon : '',
                            innerStyle: ['size20', classes.calendarSvg, 'capitalize', 'marginRight5']
                        }
                    }}
                    innerStyle={['toggleMainButtonReverse', props.theme.width < 801 ? 'buttonCalendarText' : ''].join(' ')}
                />
            </div>
        </Modal>
    );
};

export default compose(
    PropertyManager(['inAvail', 'months', 'onRangeChange', 'buttonEvent', 'closeCallback', 'modalTitle', 'modalText', 'room', 'dates', 'buttonIcon']),
    withThemeJSS({ styleFile, link: true, displayName: 'AvailDatepickerModal' })
)(AvailDatepickerModal);
